import { GA4GuideEN } from '@/core/components/help-and-support/quick-answers/ga4-guide/en'
import { GA4GuideES } from '@/core/components/help-and-support/quick-answers/ga4-guide/es'
import { useIntlSelector } from '@/core/hooks/useIntlSelector'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/help-and-support/quick-answers/ga4-guide/'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { locale } = useIntlSelector()

  switch (locale) {
    case 'en':
      return <GA4GuideEN />
    case 'es':
      return <GA4GuideES />
  }
}
